"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Grid_1 = __importDefault(require("@material-ui/core/Grid"));
var styles_1 = require("@material-ui/core/styles");
var classnames_1 = __importDefault(require("classnames"));
var sorting_1 = require("../../context/sorting");
var props_1 = require("../../context/props");
var Typography_1 = __importDefault(require("../../../Typography"));
var SortingIcon_1 = __importDefault(require("./SortingIcon"));
var DraggableIcon_1 = __importDefault(require("./DraggableIcon"));
var useStyles = (0, styles_1.makeStyles)(function (_a) {
    var palette = _a.palette;
    return ({
        container: {
            userSelect: 'none'
        },
        sorting: {
            color: palette.text.secondary,
            transition: 'all .25s linear',
            cursor: 'pointer',
            '&:hover': {
                color: palette.text.primary
            }
        },
        sortingActive: {
            color: palette.text.primary
        },
        notSortableCell: {
            color: palette.text.secondary
        }
    });
});
var DataGridHeaderColumnCell = function (props) {
    var _a;
    var _b;
    var _c = props.column, id = _c.id, label = _c.label, _d = _c.isSorting, isSorting = _d === void 0 ? false : _d, handlerColumnWidth = props.handlerColumnWidth, width = props.width, columnIndex = props.columnIndex;
    var _e = (0, sorting_1.useSortingContext)(), onSorting = _e.onSorting, _f = _e.sortingSettings, sortField = _f.sortField, sortOrder = _f.sortOrder;
    var _g = (0, props_1.usePropsContext)(), isFlexibleColumns = _g.isFlexibleColumns, classes = _g.classes;
    var innerClasses = useStyles();
    var handlerSorting = (0, react_1.useCallback)(function () {
        onSorting(id, id === sortField && sortOrder === 1 ? 0 : 1);
    }, [id, sortField, sortOrder, onSorting]);
    var containerProps = (0, react_1.useMemo)(function () { return (__assign({}, isSorting && { onClick: handlerSorting })); }, [isSorting, handlerSorting]);
    return (react_1.default.createElement(Grid_1.default, __assign({ container: true, alignItems: "center", justify: "space-between", wrap: "nowrap", classes: {
            container: (0, classnames_1.default)((_a = {},
                _a[innerClasses.container] = true,
                _a[innerClasses.sorting] = isSorting,
                _a[innerClasses.notSortableCell] = !!sortField && !isSorting,
                _a[innerClasses.sortingActive] = id === sortField,
                _a))
        } }, containerProps),
        react_1.default.createElement(Grid_1.default, { item: true, classes: { root: (_b = classes === null || classes === void 0 ? void 0 : classes.header) === null || _b === void 0 ? void 0 : _b.labelCellContainer } },
            react_1.default.createElement(Typography_1.default, { variant: "caption" },
                react_1.default.createElement("b", null, label))),
        react_1.default.createElement(Grid_1.default, { item: true },
            isSorting && (react_1.default.createElement(SortingIcon_1.default, { id: id, sortOrder: sortOrder, sortField: sortField })),
            isFlexibleColumns && (react_1.default.createElement(DraggableIcon_1.default, { handlerColumnWidth: handlerColumnWidth, width: width, columnId: id, columnIndex: columnIndex })))));
};
exports.default = DataGridHeaderColumnCell;
